// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountGuidelineException } from './account-guideline-exception';
import { ActiveStatus } from './active-status';
import { ReviewGuidelineKind } from './review-guideline-kind';
import { ReviewSeverity } from './review-severity';
import { ActiveStatusEnum } from './enums';
import { ReviewGuidelineKindEnum } from './enums';
import { ReviewSeverityEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ReviewGuideline extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(60) */
  code!: string;
  /** String */
  guidance?: string;
  /** String */
  parametersJson?: string;
  /** Enum FK reviewGuidelineKind */
  reviewGuidelineKindId!: ReviewGuidelineKindEnum;
  /** Enum FK reviewSeverity */
  reviewSeverityId!: ReviewSeverityEnum;
  /** Binary */
  rowVersion!: any;
  /** String(250) */
  title!: string;
  /** Int32 */
  version!: number;
  /** Inv FK reviewGuidelineId */
  accountGuidelineExceptions!: AccountGuidelineException[];
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK reviewGuidelineKindId */
  reviewGuidelineKind!: ReviewGuidelineKind;
  /** FK reviewSeverityId */
  reviewSeverity!: ReviewSeverity;
}

